export const HOME = '/'